/* File defines small helper functions for mostly script.js (and a few other places). They're here to make things a little cleaner. */

import { Dictionary, IntegerDictionary, LanguageCode, PNCTypes } from "./TypesAndEnums";
import { Globals, goToNextEpisode, goToPrevEpisode, runFromRoutableKeyString } from "./main";
import { Toast } from "./materialize.cjs"
declare var __IS_QUART_SERVER: boolean;

//
// Settings stuff
export function initSettingsManager(modalName = "settingsModal"):Dictionary<any> {
	let settingsInternal = {};
	let tr = document.getElementById(modalName).getElementsByTagName("tr");
	for (let i = 0; i < tr.length; i++) {
		const key = tr[i].getAttribute("setting-name");
		const settingType = tr[i].getAttribute("setting-type") || "boolean";
		if (key)
		{
			let val:any = localStorage.getItem(key);
			//localStorage items are always a string, so even if it was false it would be stored as the string "false"
			//The only way for this conditional to be false is if it is empty or undefined
			if (val) 
			{
				console.log(`[SETTINGS] Loaded ${key}=${val}`);
			}
			else
			{
				// If undefined set to false. 
				val = tr[i].getAttribute("setting-default") ?? 'false';
				console.log(`[SETTINGS] No value set in localStorage, default is ${key}=${val}`);
			}

			if (settingType === "boolean")
			{
				let booleanVal = (val === "true");
				val = booleanVal;
				
				const checkbox = <HTMLInputElement>tr[i].querySelector("[type=checkbox]");
				if (checkbox)
				{
					checkbox.checked = booleanVal;
					/* Better event binding. */
					const handleCheckboxClick = function(e) {
						settingsInternal[key] = e.target.checked;
						localStorage.setItem(key, e.target.checked);
						console.log(`[SETTINGS] Saved ${key}=${e.target.checked}`);
					};
					checkbox.addEventListener("click", handleCheckboxClick);
				}
				else
				{
					consoleError(`[SETTINGS] Setting ${key} had no checkbox defined in the HTML despite being a boolean type, cannot apply setting`);
				}
			}
			else if (settingType === "string")
			{
				const input = <HTMLInputElement>tr[i].querySelector("[type=text]");
				input.value = val;
				input.onblur = function(e){
					settingsInternal[key] = (e.target as HTMLInputElement).value;
					localStorage.setItem(key, (e.target as HTMLInputElement).value);
				};
			}
			else if (settingType === "radio")
			{
				const inputs = <NodeListOf<HTMLInputElement>>tr[i].querySelectorAll("[type=radio]");
				for (let j = 0; j < inputs.length; j++)
				{
					inputs[j].onclick = function(e){
						settingsInternal[key] = (e.target as HTMLInputElement).value;
						localStorage.setItem(key, (e.target as HTMLInputElement).value);

						//What the fuck is this doing here?
						//NightMode(SETTINGSMAN.darkTheme, false);
					};
					if (val==inputs[j].value)
					{
						inputs[j].checked = true;
					}
				}
			}
			else if (settingType === "set")
			{
				const inputs = <NodeListOf<HTMLInputElement>>tr[i].querySelectorAll("[type=checkbox]");
				val = new Set(val.split(";")); //convert from string to a set

				for (let j = 0; j < inputs.length; j++)
				{
					inputs[j].onchange = function(e){
						
						/*const checked = new Set<string>();
						inputs.forEach(cb => {
							if (cb.checked) {
								checked.add(cb.value);
							}
						});*/
						// lol lmao
						const checked = new Set<String>([...inputs].filter(cb => cb.checked).map(cb => cb.value));
						settingsInternal[key] = checked;
						const asString = Array.from(checked).join(';')
						localStorage.setItem(key, asString);
						console.log(`[SETTINGS] Saved ${key}=${asString}`);

					};
					if (val.has(inputs[j].value))
					{
						inputs[j].checked = true;
					}
				}
			}
			else
			{
				consoleError(`[SETTINGS] No support for setting type ${settingType}, ignoring.`);
			}
			settingsInternal[key] = val;
		}
	}
	return settingsInternal;
}
//
//
//

//
// Theme stuff
//
export function NightMode(newTheme='', writeCookies=true) {
	const THEMES = ['light-theme','dark-theme','black-theme'];
	let prevTheme = document.body.classList[0] || "light-theme";
	if (!newTheme || THEMES.includes(newTheme)==false)
	{
		for (let j = 0; j < THEMES.length; j++)
		{
			if (document.body.classList.contains(THEMES[j]))
			{
				prevTheme=THEMES[j];
				if (j<THEMES.length-1)
					newTheme=THEMES[j + 1];
				else
					newTheme=THEMES[0];
				break;
			}
		}
	}

	console.log("Replace ",prevTheme,"with",newTheme);
	document.body.classList.replace(prevTheme, newTheme);

	(document.querySelector("meta[name='theme-color']") as HTMLMetaElement).content = getComputedStyle(document.body).getPropertyValue('--nav-color');
	if (writeCookies)
	{
		console.log(`new theme is ${newTheme}`);
		setCookie('theme', newTheme, 180);
	}
}
//
//
//
	
export function sliceAndRemove(str, begin, end) {
	return str.slice(0,begin) + str.slice(end);
}

export function getFromTag(str,tag) {
	const beginTag = `<${tag}>`;
	const endTag = `</${tag}>`;
	let n = str.indexOf(beginTag);
	let nn = str.indexOf(endTag); //Because somehow MICA writes text with opening tags and without closing tags
	if (n != -1 && nn != -1){
		return str.slice(n + beginTag.length, nn);
	}
	return null;
}

export function removeTag(str,tag) {
	const beginTag = `<${tag}>`;
	const endTag = `</${tag}>`;
	return sliceAndRemove(str, str.indexOf(beginTag), str.indexOf(endTag) + endTag.length);
}

export function playNewAudio(fileName) {
	let audioPlayer = <HTMLAudioElement>document.getElementById('audioPlayer');
	audioPlayer.src = `${fileName}.mp3`
	//(audioPlayer.getElementsByClassName('a_ogg')[0] as HTMLSourceElement).src = `${fileName}.ogg`;
	//(audioPlayer.getElementsByClassName('a_mp3')[0] as HTMLSourceElement).src = `${fileName}.mp3`; //Imagine using a browser that doesn't support ogg
	audioPlayer.load();
	audioPlayer.play();
}

export function playSFX(fileName) {
	let audioPlayer = <HTMLAudioElement>document.getElementById('sfxPlayer');
	(audioPlayer.getElementsByClassName('sfx_ogg')[0] as HTMLSourceElement).src = `${fileName}.ogg`;
	//audioPlayer.getElementsByClassName('a_mp3')[0].src = fileName+".mp3" //Imagine using a browser that doesn't support ogg
	audioPlayer.load();
	audioPlayer.play();
}

//Anti-XSS
export function sanitize(string) {
	const map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#x27;',
		"/": '&#x2F;',
		"`": '&grave;'
	};
	const reg = /[&<>"'/]/ig;
	return string.replace(reg, (match)=>(map[match]));
}

//Converts GFL's text modifiers into HTML elements, as you might have guessed.
//TODO: Ignore ALL unknown/illegal codes, not just <script>
//let allowedHTMLTags = ['color','size','b','i','u','q','s']
/**
 * @date 2024-03-28
 * @param {string} message
 * @returns {string} - HTML formatted message
 * @description takes a string containing PNC's text modifiers and reformats it for HTML
 */
export function parsePNCTextModifiers(message) {
	if (typeof(message) !== "string") return message;

	message = message.replaceAll(/<script>/g, "&lt;script&gt;") /* script tags */
                     .replaceAll(/<\/script>/g, "&lt;&#x2F;script&gt;") /* script tags */
                     .replaceAll(/<cmdr>/g, Globals.SETTINGS.playerName || Globals.DefaultPlayerName) /* commander name tag */
                     .replaceAll(/"/g, "&quot;") /* escaped quotes */
                     .replaceAll(/<color=(.*?)>(.*?)<\/color>/g, /* colored text tags */
                              `<span class='coloredDialogue' style='color:$1'>$2</span>`)
                     .replaceAll(/<size=(.*?)>(.*?)<\/size>/g, /* sized text tags - pnc text size is 35px */
                              (_, size, text) => `<span class='sizedDialogue' style='font-size:${(size / 35) * 100}%'>${text}</span>`)
                     .replaceAll(/<a\s+href=Des:(\d+)\s*>(.+?)<\/a>/g,  /* desination tags - map to button */
                              `<button class='tooltip' data-id="$1">$2</button>`)
                     .replaceAll(/#n/g, "<br>").replaceAll(/\n/g, "<br>"); /* newline characters */

    return message;
}

function keyboardHandlerForStoryBox(e) {
	//console.log(e);

	const thisElementIdx = parseInt(e.target.id.match(/\d+$/)?.[0]);
	if (isNaN(thisElementIdx)) //Surely just doing a try-catch is less effort
		return false;

	if (e.key == "ArrowDown")
	{
		const el = document.getElementById(`storyBox${thisElementIdx+1}`);
		if (el)
		{
			el.focus();
			el.scrollIntoView({behavior:'auto',block:'center',inline:'center'});
			e.preventDefault();
		}
	}
	else if (e.key == "ArrowUp")
	{
		if (thisElementIdx > 0)
		{
			const el = document.getElementById(`storyBox${thisElementIdx-1}`);
			if (el)
			{
				el.focus();
				el.scrollIntoView({behavior:'auto',block:'center',inline:'center'});
				e.preventDefault();
			}
		}
	}
	else if (e.ctrlKey && e.key == "ArrowLeft")
	{
		goToPrevEpisode();
	}
	else if (e.ctrlKey && e.key == "ArrowRight")
	{
		goToNextEpisode();
	}
}


/**
 * Why is this in helpers???? it's related to the database?????
 * @param {any} lang The language to set the site/story to. Duh.
 * @returns {Promise} A promise that finishes when the new language content is loaded. (You can discard if you want.)
 */
export async function SetLanguage(lang:LanguageCode ) {
	//setTranslation(lang);
	//currentLanguage=lang;
	if (lang=="za/")
	{
		Globals.CurrentLanguage="en/";
	}
	else
	{
		Globals.CurrentLanguage = lang;
	}
	setCookie("language",lang,180);

	return Promise.all(
		[
			//Promise.all is multithreaded, it starts all requests at the same time and waits until they're finished
			`LuaConfigs.noun_des.json`,
			"LuaConfigs.locale_text.json",
			"LuaConfigs.resource_model.json",
		].map(f => fetch(
			//Example: LuaConfigs.noun_des.json -> "avgtxt/en/LuaConfigs.noun_des.json"
			"avgtxt/" + Globals.CurrentLanguage + f
		).then(resp => resp.json()))
	).then((files) => {
		let DICTIONARY:IntegerDictionary<PNCTypes.NounData> = files[0];

		//MICA mixes int and string keys because lua allows that.
		//When you do ipairs() in lua it's actually a loop like this
		// for (let i = 1, val; val = table[i]; i++)
		// so they won't see the typeListDic key in ipairs but they
		// can still manually access it... Anyways we don't need this so delete it
		delete DICTIONARY['typeListDic']

		let LOCALE_TEXT = files[1];
		let MODEL_CFG = files[2];
		
		Object.values(DICTIONARY).forEach(d => {
			if (typeof d.des === 'number') {
				d.des = LOCALE_TEXT[d.des];
			}
		});

		Globals.DICTIONARY = DICTIONARY;
		Globals.LOCALE_TEXT = LOCALE_TEXT;
		Globals.MODEL_CFG = MODEL_CFG;
	})
}

export function createDropDownBox(key:PNCTypes.StoryCategory, container:HTMLElement, chapters:PNCTypes.Chapter[]) {
	

	const _dropDownTrigger_ = document.createElement('a');
	//_dropDownTrigger_.href = "#";
	_dropDownTrigger_.classList.add('dropdown-trigger');
	_dropDownTrigger_.classList.add('btn');
	
	const _dropDown_ = document.createElement('ul');
	_dropDown_.classList.add('dropdown-content');

	const CURRENT_PAGE_BASE_URL = window.location.pathname;

	for(let i = 0; i < chapters.length;i++) {
		//Div that contains the dropdown trigger button
		const flexboxDiv = document.createElement('div');

		
		const dropDownTrigger = <HTMLAnchorElement>_dropDownTrigger_.cloneNode(true)
		dropDownTrigger.classList.add('dropdown-trigger');
		dropDownTrigger.classList.add('btn');
		let dropdownIdxKey = chapters[i].num;
		if (dropdownIdxKey < 0)
			dropdownIdxKey = i;
		//Do not forget this or bad things will happen
		dropDownTrigger.setAttribute('data-target', `dropdown-${key}-${dropdownIdxKey}`);
		dropDownTrigger.innerText = chapters[i].name;
		const dropDown = <HTMLUListElement>_dropDown_.cloneNode(true);
		dropDown.id = `dropdown-${key}-${dropdownIdxKey}`;
		/*******************************************************************/
		for(let j = 0; j < chapters[i].episodes.length; ++j) {
			const thisEpisode = chapters[i].episodes[j];
			/* Do name stuff. */
			let epName = thisEpisode.name;
			let category = thisEpisode.category || 0;

			//TODO: This adds the number prefixes to the listing
			// if(category == PNCTypes.EpisodeCategory.NORMAL || category == PNCTypes.EpisodeCategory.DARK) {
			// 	let prefix = thisEpisode?.type.charAt(0) + thisEpisode?.type.slice(1).toLowerCase();
			// 	epName = `${prefix} ${thisEpisode.num}${category == PNCTypes.EpisodeCategory.DARK ? "D" : ""}: 
			// 		${thisEpisode.name}`;
			// }
			
			/* Create list item and add to dropdown. */
			let tempLi = document.createElement('li');

			let episodeLink;
			if (__IS_QUART_SERVER) {
				episodeLink = `${window.location.pathname}?permalink=${chapters[i].episodes[j].permalink}`
			}
			else {
				episodeLink = `#${chapters[i].episodes[j].permalink}`
			}
			tempLi.innerHTML = `<a href='${episodeLink}'>${epName}</a>`;
			tempLi.addEventListener('click', function(event) {
				event.preventDefault(); // Stop navigation
				if (runFromRoutableKeyString(chapters[i].episodes[j].permalink)) {
					history.pushState(null, '', episodeLink); // Rewrite URL
				}
			});


			if(category == PNCTypes.EpisodeCategory.DARK)
				tempLi.classList.add("dark-stage");
			dropDown.appendChild(tempLi);
		}
		/* Finalize. */
		flexboxDiv.appendChild(dropDownTrigger);
		flexboxDiv.appendChild(dropDown);
		container.appendChild(flexboxDiv);
	}

	
}

/* 
   >"we don't use cookies"
   >uses cookies
   ???  
*/

//These are only for the night theme and current language,
//since the page should be rendered in advance for those
function setCheckboxFromCookie(idOfCheckbox:string, defaultValueIfNotSet) {
	let c = getCookie(idOfCheckbox);
	if (c==undefined || c=="")
	{
		//Cookies can only be strings
		c = defaultValueIfNotSet.toString();
		setCookie(idOfCheckbox,defaultValueIfNotSet,180);
	}
	console.assert(document.getElementById(idOfCheckbox) != null,`no element named ${idOfCheckbox}`);
	console.log(`Setting ${idOfCheckbox} to ${c}`);
	(document.getElementById(idOfCheckbox) as HTMLInputElement).checked = (c=='true');
}
function setCookieFromCheckbox(idOfCheckbox:string) {
	setCookie(
		idOfCheckbox,
		(document.getElementById(idOfCheckbox) as HTMLInputElement).checked,
		180
	);
}
export function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = `expires=${d.toUTCString()}`;
	document.cookie = `${cname}=${cvalue};SameSite=Lax;${expires};path=/`;
}

export function getCookie(cname) {
	var name = `${cname}=`;
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function eraseCookie(cname) {
	document.cookie = `${cname}=; Max-Age=0;`;
}

function consoleWarn(param)
{
	console.log(`%c ${param}`,'background: black; color: yellow');
}

function consoleError(param)
{
	console.log(`%c ${param}`,'background: black; color: red');
}

export function ShowToast(o:object) {
	new Toast(o)
}